import { UserInfo } from "./types/userInfo";

const SESSION_KEYS = [
  "rh-user",
  "rh-userId",
  "rh-ativo",
  "rh-token",
  "rh-refreshToken",
  "rh-pessoalBairro",
  "rh-cidade",
  "rh-pessoalUf",
  "rh-pessoalEntrevista",
  "rh-idade",
  "rh-email",
  "authkey",
] as const;

export function clearCandidateSession(): void {
  SESSION_KEYS.forEach((key) => localStorage.removeItem(key));
}

export function getCandidateToken(): string | null {
  return localStorage.getItem("rh-token");
}

export function isCandidateLoggedIn(): boolean {
  return !!getCandidateToken();
}

export function getCandidateUserInfo(): UserInfo | undefined {
  const token = getCandidateToken();
  const id = localStorage.getItem("rh-userId");
  if (!token || !id) {
    return undefined;
  }

  const fullName = localStorage.getItem("rh-user") || "";
  const parts = fullName.trim().split(/\s+/).filter(Boolean);
  const firstName = parts[0] || "";
  const lastName = parts.slice(1).join(" ");

  return {
    id,
    email: localStorage.getItem("rh-email") || "",
    firstName,
    lastName,
    job: "",
    progress: 0,
    role: "Candidate",
  };
}

/** Remove auth legado (mock) — não é mais usado. */
export function cleanupLegacyAuthState(): void {
  localStorage.removeItem("authkey");
}

export function syncCandidateSessionFromApi(data: Record<string, unknown>): void {
  const nome = data.pessoal_nome;
  if (typeof nome === "string" && nome.trim()) {
    localStorage.setItem("rh-user", nome);
  }

  const email = data.pessoal_email;
  if (typeof email === "string") {
    localStorage.setItem("rh-email", email);
  }

  const cadFinalizado = data.cad_finalizado;
  if (cadFinalizado != null) {
    localStorage.setItem("rh-ativo", String(cadFinalizado));
  }

  const cidade = data.pessoal_cidade;
  if (typeof cidade === "string") {
    localStorage.setItem("rh-cidade", cidade);
  }

  const bairro = data.pessoal_bairro;
  if (typeof bairro === "string") {
    localStorage.setItem("rh-pessoalBairro", bairro);
  }

  const uf = data.pessoal_uf;
  if (typeof uf === "string") {
    localStorage.setItem("rh-pessoalUf", uf);
  }
}
